const header: HTMLElement | null = document.querySelector('.site-header');

export const stickyHeader = (): void => {
  if (!header) return;

  const headerHeight: number = header.offsetHeight;
  const documentScrollTop: number = window.scrollY;

  if (documentScrollTop > headerHeight) {
    header.classList.add('sticky');
  } else {
    header.classList.remove('sticky');
  }

  if (header && matchMedia('(min-width: 72em)').matches) {
    window.onscroll = (): void => {
      stickyHeader();
    };
  }
};
